<nav #pagesnavbar class="navbar navbar-primary navbar-transparent navbar-absolute">
    <div class="container">
        <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navigation-example-2" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" routerLinkActive="active" [routerLink]="['/dashboard']">Light Bootstrap Dashboard PRO Angular</a>
        </div>
        <div class="collapse navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
                <li>
                    <a routerLinkActive="active" [routerLink]="['/dashboard']">
                        <i class="fa fa-tachometer" aria-hidden="true"></i>
                        <p>Dashboard</p>
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" [routerLink]="['/auth/login']">
                        <i class="fa fa-sign-in" aria-hidden="true"></i>
                        <p>Login</p>
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" [routerLink]="['/auth/register']">
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                        <p>Register</p>
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" [routerLink]="['/auth/lock']">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <p>Lock Screen</p>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>
